import { Link, useNavigate, useParams } from 'react-router-dom'
import './Article.css'
import { useEffect, useState } from 'react'
import axios from 'axios'
import MyNavbar from '../../components/navbar/MyNavbar'
import { Button, Col, Container, Row } from 'react-bootstrap'

import { BsPencilSquare } from "react-icons/bs";
import { BiTimeFive, BiCategoryAlt } from "react-icons/bi";
import { MdDelete, MdOutlineEditCalendar } from "react-icons/md";
import Swal from 'sweetalert2'



function Article() {
    const articleId = useParams().articleId
    const [articleData, setArticleData] = useState({})
    // we define this hooks for delete btn after delete aricle be success we come back to main page
    const navigate = useNavigate()

    useEffect(() => {
        axios.get(`http://localhost/react/api/articles/?id=${articleId}`)
        // we use [0] here for when we get id number after that we write [0] for don't show all arrays info just The one chosen 
            .then(response => setArticleData(response.data.data[0]))

    }, [])
    

    // delete btn function 
    // we use axios for delete the article by id value and Sweetalert for confirm delete options.
    const deleteArticleHandler = (articleId) => {
        Swal.fire({
            title: "Are you sure you want to delete the article?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No"
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Deleted",
                    text: "Your article has been deleted.",
                    icon: "success"
                });

                axios.delete(`http://localhost/react/api/articles/?id=${articleId}`)
                // we use navigate here for come back to main page.
                navigate('/')
            }
        });

    }


    return (
        <>
            <MyNavbar />
            <Container>
                <Row className='gy-4' style={{ marginTop: '75px' }}>
                    {/* pic and info */}
                    <Col lg={4}>
                        <div className="articleCardContainer px-2">
                            {/* we get information from articleData that save our information */}
                            <div className="cardHeader">
                                <img src={articleData.image} alt="article-image" />
                                <h4>{articleData.title}</h4>
                            </div>

                            <div className="cardBody">
                                <p>
                                    <BsPencilSquare size='20px' />
                                    Author : <b>{articleData.writter}</b>
                                </p>
                                <p>
                                    <BiTimeFive size='20px' />
                                    Duration : <b>{articleData.readingTime}m</b>
                                </p>
                                <p>
                                    <BiCategoryAlt size='20px' />
                                    Category : <b>{articleData.category}</b>
                                </p>

                            </div>

                            <div className="cardFooter">
                                {/* we use arrow function for get id value and Prevent execution */}
                                <Button onClick={() => deleteArticleHandler(articleId)} variant='outline-danger'> <MdDelete size='25px' /> Delete Article</Button>
                                <Link to={`/edit-article/${articleId}`}>
                                      <Button  variant='outline-primary'> <MdOutlineEditCalendar size='25px' /> Edit Article</Button>
                                </Link>

                            </div>

                        </div>

                    </Col>
                    {/* text description */}
                    <Col className='second-col' lg={8}>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi odio neque sunt libero laborum eos quae eius blanditiis modi molestiae. Minus eaque ipsum, tempora aspernatur ex incidunt modi nemo deleniti.
                            Explicabo sint rem aut harum ipsa est perspiciatis illum, magni esse soluta. Quasi assumenda voluptatum inventore ipsum rem, saepe dicta totam fuga laborum at excepturi a consectetur mollitia ut sint!
                            Dicta, nobis enim. Provident impedit natus nemo fuga similique sequi alias commodi sapiente optio repellendus dignissimos accusamus enim molestiae tempora ut voluptate quisquam illum, molestias quasi ipsa pariatur? Nihil, dolore.
                            Eveniet labore pariatur animi dignissimos molestias sapiente laboriosam molestiae ipsam! Totam nesciunt dicta minus veniam praesentium, sit labore sed incidunt minima suscipit doloremque fuga harum quisquam alias voluptatibus perferendis nihil?</p>

                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi odio neque sunt libero laborum eos quae eius blanditiis modi molestiae. Minus eaque ipsum, tempora aspernatur ex incidunt modi nemo deleniti.
                            Explicabo sint rem aut harum ipsa est perspiciatis illum, magni esse soluta. Quasi assumenda voluptatum inventore ipsum rem, saepe dicta totam fuga laborum at excepturi a consectetur mollitia ut sint!
                            Dicta, nobis enim. Provident impedit natus nemo fuga similique sequi alias commodi sapiente optio repellendus dignissimos accusamus enim molestiae tempora ut voluptate quisquam illum, molestias quasi ipsa pariatur? Nihil, dolore.
                            Eveniet labore pariatur animi dignissimos molestias sapiente laboriosam molestiae ipsam! Totam nesciunt dicta minus veniam praesentium, sit labore sed incidunt minima suscipit doloremque fuga harum quisquam alias voluptatibus perferendis nihil?</p>

                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi odio neque sunt libero laborum eos quae eius blanditiis modi molestiae. Minus eaque ipsum, tempora aspernatur ex incidunt modi nemo deleniti.
                            Explicabo sint rem aut harum ipsa est perspiciatis illum, magni esse soluta. Quasi assumenda voluptatum inventore ipsum rem, saepe dicta totam fuga laborum at excepturi a consectetur mollitia ut sint!
                            Dicta, nobis enim. Provident impedit natus nemo fuga similique sequi alias commodi sapiente optio repellendus dignissimos accusamus enim molestiae tempora ut voluptate quisquam illum, molestias quasi ipsa pariatur? Nihil, dolore.
                            Eveniet labore pariatur animi dignissimos molestias sapiente laboriosam molestiae ipsam! Totam nesciunt dicta minus veniam praesentium, sit labore sed incidunt minima suscipit doloremque fuga harum quisquam alias voluptatibus perferendis nihil?</p>

                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi odio neque sunt libero laborum eos quae eius blanditiis modi molestiae. Minus eaque ipsum, tempora aspernatur ex incidunt modi nemo deleniti.
                            Explicabo sint rem aut harum ipsa est perspiciatis illum, magni esse soluta. Quasi assumenda voluptatum inventore ipsum rem, saepe dicta totam fuga laborum at excepturi a consectetur mollitia ut sint!
                            Dicta, nobis enim. Provident impedit natus nemo fuga similique sequi alias commodi sapiente optio repellendus dignissimos accusamus enim molestiae tempora ut voluptate quisquam illum, molestias quasi ipsa pariatur? Nihil, dolore.
                            Eveniet labore pariatur animi dignissimos molestias sapiente laboriosam molestiae ipsam! Totam nesciunt dicta minus veniam praesentium, sit labore sed incidunt minima suscipit doloremque fuga harum quisquam alias voluptatibus perferendis nihil?</p>

                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi odio neque sunt libero laborum eos quae eius blanditiis modi molestiae. Minus eaque ipsum, tempora aspernatur ex incidunt modi nemo deleniti.
                            Explicabo sint rem aut harum ipsa est perspiciatis illum, magni esse soluta. Quasi assumenda voluptatum inventore ipsum rem, saepe dicta totam fuga laborum at excepturi a consectetur mollitia ut sint!
                            Dicta, nobis enim. Provident impedit natus nemo fuga similique sequi alias commodi sapiente optio repellendus dignissimos accusamus enim molestiae tempora ut voluptate quisquam illum, molestias quasi ipsa pariatur? Nihil, dolore.
                            Eveniet labore pariatur animi dignissimos molestias sapiente laboriosam molestiae ipsam! Totam nesciunt dicta minus veniam praesentium, sit labore sed incidunt minima suscipit doloremque fuga harum quisquam alias voluptatibus perferendis nihil?</p>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Article